<template>
  <footer class="footer" id="contact">
    <div class="footer-background"></div>
    <div class="container">
      <div class="footer-content">
        <div class="footer-info">
          <h3 class="footer-logo">宁波市纪煜科技有限公司</h3>
          <p class="footer-subtitle">NINGBO JIYU TECHNOLOGY</p>
          <!-- <p class="footer-motto">AI 驱动 · 低代码赋能 · 数据创造价值</p> -->
          
          <div class="contact-info">
            <div class="contact-item">
              <i class="fas fa-map-marker-alt"></i>
              <span>浙江省宁波市海曙区翠柏路89号C座4楼409</span>
            </div>
            <div class="contact-item">
              <i class="fas fa-phone"></i>
              <span>176 0570 2079</span>
            </div>
            <div class="contact-item">
              <i class="fas fa-envelope"></i>
              <span>nbjy@nbjiyu-tech.cn</span>
            </div>
            <div class="contact-item">
              <i class="fas fa-clock"></i>
              <span>周一至周五 8:30-17:00</span>
            </div>
          </div>
        </div>
        
        <div class="footer-links">
          <h4>快速链接</h4>
          <ul>
            <li><a href="#home">首页</a></li>
            <li><a href="#advantages">核心优势</a></li>
            <li><a href="#platform">技术平台</a></li>
            <li><a href="#solutions">解决方案</a></li>
            <li><a href="#timeline">发展历程</a></li>
          </ul>
        </div>
        
        <div class="footer-contact">
          <h4>联系我们</h4>
          <p>如果您有项目需求或合作意向，请随时与我们联系</p>
          
          <form class="contact-form" @submit.prevent="submitContact">
            <div class="form-group">
              <input type="text" placeholder="您的姓名" v-model="contact.name" required>
            </div>
            <div class="form-group">
              <input type="tel" placeholder="联系电话" v-model="contact.phone">
            </div>
            <div class="form-group">
              <textarea placeholder="项目需求或留言" v-model="contact.message" rows="3"></textarea>
            </div>
            <button type="submit" class="btn btn-accent">发送咨询</button>
          </form>
        </div>
      </div>
      
      <div class="footer-bottom">
        <p>&copy; 2025-2026 宁波市纪煜科技有限公司 <a href="https://beian.miit.gov.cn/#/Integrated/index" target="_blank" rel="noopener noreferrer" class="beian-link">浙ICP备2026017845号</a><img src="/beian.png" alt="备案图标" style="height: 16px; margin: 0 5px; vertical-align: text-bottom;"><a href="https://beian.zj.gov.cn/index.htm" rel="noreferrer" target="_blank" class="beian-link">浙公网安备33020302002080号</a> 版权所有</p>
        <div class="social-links">
          <div class="wechat-qr-wrapper">
            <a class="wechat-link">
              <i class="fab fa-weixin"></i>
            </a>
            <div class="wechat-qr-code">
              <img src="@/assets/jiehui.png" alt="微信二维码">
              <span>周经理</span>
            </div>
          </div>
          <!-- <a><i class="fab fa-weibo"></i></a> -->
          <div class="qq-qr-wrapper">
            <a class="qq-link">
              <i class="fab fa-qq"></i>
            </a>
            <div class="qq-qr-code">
              <img src="@/assets/qq.jpg" alt="QQ二维码">
              <span>唐经理</span>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: 'Footer',
  data() {
    return {
      contact: {
        name: '',
        email: '',
        phone: '',
        message: ''
      },
      opacity: 0
    }
  },
  mounted() {
    window.addEventListener('scroll', this.handleScroll);
    // 初始化时立即检查位置
    this.$nextTick(() => {
      this.handleScroll();
    });
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.handleScroll);
  },
  methods: {
    handleScroll() {
      const footerElement = document.getElementById('contact');
      if (!footerElement) return;
      
      const footerTop = footerElement.offsetTop;
      const footerHeight = footerElement.offsetHeight;
      const scrollTop = window.pageYOffset;
      const windowHeight = window.innerHeight;
      
      // 计算视口底部位置
      const viewportBottom = scrollTop + windowHeight;
      // 计算视口顶部位置
      const viewportTop = scrollTop;
      
      // 情况1: 视口完全在footer上方 (还没进入)
      if (viewportBottom <= footerTop) {
        this.opacity = 0;
      }
      // 情况2: 视口完全在footer下方 (已经离开)
      else if (viewportTop >= footerTop + footerHeight) {
        this.opacity = 0;
      }
      // 情况3: 视口正在进入footer (从上往下滚动)
      else if (viewportTop < footerTop && viewportBottom > footerTop) {
        const distance = viewportBottom - footerTop;
        this.opacity = Math.min(1, distance / 300); // 300px内淡入
      }
      // 情况4: 视口正在离开footer (从下往上滚动)
      else if (viewportTop < footerTop + footerHeight && viewportBottom > footerTop + footerHeight) {
        const distance = footerTop + footerHeight - viewportTop;
        this.opacity = Math.min(1, distance / 300); // 300px内淡出
      }
      // 情况5: 视口完全在footer内部
      else {
        this.opacity = 1;
      }
    },
    submitContact() {
      alert(`感谢 ${this.contact.name} 的咨询！我们会尽快与您联系。`);
      this.contact = {
        name: '',
        email: '',
        phone: '',
        message: ''
      };
    }
  }
}
</script>

<style scoped>
.footer {
  position: relative;
  color: white;
  padding: 60px 0 30px;
  min-height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-background {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: url('@/assets/vx.png') center/cover no-repeat;
  z-index: -1;
  opacity: v-bind(opacity);
  transition: opacity 0.5s ease;
}

.footer-content {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 40px;
  margin-bottom: 50px;
  position: relative;
  z-index: 2;
}

.footer-info {
  padding-right: 20px;
}

.footer-logo {
  font-size: 1.8rem;
  color: white;
  margin-bottom: 10px;
  font-weight: 700;
  /* 增强文字阴影 */
  text-shadow: 
    0 0 10px rgba(0, 0, 0, 0.8),
    0 2px 4px rgba(0, 0, 0, 0.5);
  animation: glow 2s infinite alternate;
  transition: all 0.3s ease;
}

/* 新增：公司名称悬停效果 */
.footer-logo:hover {
  transform: translateY(-3px);
  text-shadow: 
    0 0 15px rgba(0, 0, 0, 0.9),
    0 4px 8px rgba(0, 0, 0, 0.6);
}

.footer-subtitle {
  color: rgba(255, 255, 255, 0.95);
  margin-bottom: 20px;
  font-size: 1rem;
  letter-spacing: 1px;
  /* 增强文字阴影 */
  text-shadow: 0 1px 3px rgba(0, 0, 0, 0.7);
  transition: all 0.3s ease;
}

/* 新增：副标题悬停效果 */
.footer-subtitle:hover {
  transform: translateY(-2px);
  text-shadow: 0 2px 5px rgba(0, 0, 0, 0.8);
}

.footer-motto {
  font-size: 1.2rem;
  color: #d4af37;
  margin-bottom: 30px;
  font-style: italic;
  /* 增强文字阴影 */
  text-shadow: 
    0 0 8px rgba(0, 0, 0, 0.6),
    0 1px 2px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
}

/* 新增：标语悬停效果 */
.footer-motto:hover {
  transform: translateY(-2px);
  text-shadow: 
    0 0 12px rgba(0, 0, 0, 0.7),
    0 2px 4px rgba(0, 0, 0, 0.6);
  color: #e6c158;
}

.contact-item {
  display: flex;
  align-items: flex-start;
  margin-bottom: 15px;
  color: rgba(255, 255, 255, 0.95);
  transition: all 0.3s ease;
  /* 增强文字阴影 */
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}

/* 新增：联系信息项悬停效果 */
.contact-item:hover {
  transform: translateX(5px);
  color: white;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.8);
}

.contact-item i {
  margin-right: 10px;
  color: #d4af37;
  margin-top: 3px;
  text-shadow: 0 0 5px rgba(212, 175, 55, 0.5);
}

/* 新增：图标悬停效果 */
.contact-item:hover i {
  color: #e6c158;
  text-shadow: 0 0 8px rgba(212, 175, 55, 0.7);
}

.footer-links h4, .footer-contact h4 {
  font-size: 1.3rem;
  color: white;
  margin-bottom: 20px;
  padding-bottom: 10px;
  border-bottom: 2px solid #d4af37;
  display: inline-block;
  /* 增强文字阴影 */
  text-shadow: 
    0 0 8px rgba(0, 0, 0, 0.7),
    0 1px 3px rgba(0, 0, 0, 0.5);
  transition: all 0.3s ease;
}

.footer-links a {
  color: rgba(255, 255, 255, 0.9);
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
  /* 增强文字阴影 */
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.5);
}

.footer-links a::before {
  content: '→';
  position: absolute;
  left: -20px;
  opacity: 0;
  transition: opacity 0.3s, left 0.3s;
}

.footer-links a:hover {
  color: #d4af37;
  padding-left: 10px;
}

.footer-links a:hover::before {
  opacity: 1;
  left: -25px;
}

.footer-contact p {
  color: rgba(255, 255, 255, 0.9);
  margin-bottom: 20px;
  line-height: 1.6;
  transition: all 0.3s ease;
  /* 增强文字阴影 */
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}

.contact-form {
  margin-top: 20px;
}

.form-group {
  margin-bottom: 15px;
}

.form-group input, .form-group textarea {
  width: 100%;
  padding: 12px 15px;
  border: 1px solid rgba(255, 255, 255, 0.3);
  background-color: rgba(0, 0, 0, 0.2);
  backdrop-filter: blur(5px);
  border-radius: 4px;
  color: white;
  font-size: 1rem;
  transition: all 0.3s ease;
}

/* 新增：输入框悬停效果 */
.form-group input:hover, .form-group textarea:hover {
  border-color: #d4af37;
  box-shadow: 0 0 8px rgba(212, 175, 55, 0.4);
  transform: scale(1.02);
}

.form-group input:focus, .form-group textarea:focus {
  outline: none;
  border-color: #d4af37;
  box-shadow: 0 0 10px rgba(212, 175, 55, 0.5);
}

.form-group input::placeholder, .form-group textarea::placeholder {
  color: rgba(255, 255, 255, 0.6);
}

.form-group textarea {
  resize: vertical;
  min-height: 100px;
}

.contact-form .btn {
  width: 100%;
  font-size: 1.1rem;
  padding: 14px;
  background: rgba(212, 175, 55, 0.9);
  color: #0a1f5c;
  border: none;
  transition: all 0.3s ease;
}

.contact-form .btn:hover {
  background: rgba(212, 175, 55, 1);
  transform: translateY(-3px);
  box-shadow: 0 5px 15px rgba(212, 175, 55, 0.4);
}

.footer-bottom {
  border-top: 1px solid rgba(255, 255, 255, 0.2);
  padding-top: 20px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  flex-wrap: wrap;
  position: relative;
  z-index: 2;
  /* 为版权信息添加背景 */
  background-color: rgba(0, 0, 0, 0.4);
  padding: 15px 20px;
  border-radius: 8px;
  margin-top: 20px;
}

.footer-bottom p {
  color: rgba(255, 255, 255, 0.9);
  font-size: 0.9rem;
  /* 增强文字阴影 */
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.6);
}

.beian-link {
  color: rgba(255, 255, 255, 0.95);
  text-decoration: none;
  transition: all 0.3s ease;
  position: relative;
}

.beian-link:hover {
  color: #d4af37;
  text-decoration: underline;
  text-decoration-color: #d4af37;
}

.social-links {
  display: flex;
  gap: 15px;
}

.social-links a {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
  border-radius: 50%;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.social-links a:hover {
  background-color: #d4af37;
  color: #0a1f5c;
  transform: translateY(-3px) rotate(10deg);
  box-shadow: 0 0 15px rgba(212, 175, 55, 0.6);
}

/* 微信二维码样式 */
.wechat-qr-wrapper {
  position: relative;
  display: inline-flex;
}

.wechat-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
  border-radius: 50%;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.wechat-link:hover {
  background-color: #d4af37;
  color: #0a1f5c;
  transform: translateY(-3px) rotate(10deg);
  box-shadow: 0 0 15px rgba(212, 175, 55, 0.6);
}

.wechat-qr-code {
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 1001;
}

.wechat-qr-code img {
  width: 120px;
  height: 120px;
  display: block;
}

/* 修改：添加周经理文字样式 */
.wechat-qr-code span {
  display: block;
  text-align: center;
  margin-top: 8px;
  color: #333;
  font-size: 0.9rem;
  font-weight: bold;
}

.wechat-qr-wrapper:hover .wechat-qr-code {
  opacity: 1;
  visibility: visible;
}

/* QQ二维码样式 */
.qq-qr-wrapper {
  position: relative;
  display: inline-flex;
}

.qq-link {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  background-color: rgba(0, 0, 0, 0.3);
  backdrop-filter: blur(5px);
  border-radius: 50%;
  color: white;
  font-size: 1.2rem;
  transition: all 0.3s ease;
  text-decoration: none;
  border: 1px solid rgba(255, 255, 255, 0.2);
}

.qq-link:hover {
  background-color: #d4af37;
  color: #0a1f5c;
  transform: translateY(-3px) rotate(10deg);
  box-shadow: 0 0 15px rgba(212, 175, 55, 0.6);
}

.qq-qr-code {
  position: absolute;
  bottom: 50px;
  left: 50%;
  transform: translateX(-50%);
  background: white;
  padding: 10px;
  border-radius: 8px;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  opacity: 0;
  visibility: hidden;
  transition: opacity 0.3s ease, visibility 0.3s ease;
  z-index: 1001;
}

.qq-qr-code img {
  width: 120px;
  height: 120px;
  display: block;
}

/* 修改：添加唐总文字样式 */
.qq-qr-code span {
  display: block;
  text-align: center;
  margin-top: 8px;
  color: #333;
  font-size: 0.9rem;
  font-weight: bold;
}

.qq-qr-wrapper:hover .qq-qr-code {
  opacity: 1;
  visibility: visible;
}

@media (max-width: 768px) {
  .footer-content {
    grid-template-columns: 1fr;
  }
  
  .footer-bottom {
    flex-direction: column;
    text-align: center;
    gap: 20px;
  }
  
  /* 在移动端，二维码显示在右侧 */
  .wechat-qr-code {
    bottom: auto;
    top: 50%;
    left: calc(100% + 10px);
    transform: translateY(-50%);
  }
}
</style>